export default "__VITE_ASSET__D9ROYbM9__"